import { createContext, useContext } from 'react';
import { ICheckInInstance } from 'mod/checkIn/useCheckIn';
import { ICheckInData } from 'mod/checkIn/interface';

export type ICheckInContext = Omit<ICheckInInstance, 'data'> & {
    data: ICheckInData;
};

export const CheckInContext = createContext<ICheckInContext>({} as ICheckInContext);

export function useCheckInContext(): ICheckInContext {
    return useContext(CheckInContext);
}
